export const tableData = {
  tHead: [
    {
      key: 'name',
      dataIndex: 'name',
      title: '名称',
      width: '350px'
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '质量等级',
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
    },
    {
      key: 'label1',
      dataIndex: 'label1',
      title: '',
      slot:'operate2019',
    },
    {
      key: 'label2',
      dataIndex: 'label2',
      title: '',
      slot:'operate2020',
    },
    {
      key: 'label3',
      dataIndex: 'label3',
      title: '',
      slot:'operate2021',
    },
    {
      title: '评分详情',
      slot:'operatehz',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  },
};
export const tableData1 = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '评估指标',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '指标内容',
      width:'200px'
    },
    {
      key: 'score1',
      dataIndex: 'score1',
      title: '',
      slot:'operate2019',
    },
    {
      key: 'score2',
      dataIndex: 'score2',
      title: '',
      slot:'operate2020',
    },
    {
      key: 'score3',
      dataIndex: 'score3',
      title: '',
      slot:'operate2021',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
